	export enum HearingAidTrialsWeeksRangeEnum {
		_0To2Weeks = 1,
		_2To4Weeks = 2,
		_4To6Weeks = 3,
		_6AndMoreWeeks = 4
	}
